import { render, staticRenderFns } from "./SupplierTab.vue?vue&type=template&id=55f2dbce&scoped=true&"
import script from "./SupplierTab.vue?vue&type=script&lang=js&"
export * from "./SupplierTab.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTab.vue?vue&type=style&index=0&id=55f2dbce&prod&scoped=true&lang=css&"
import style1 from "./SupplierTab.vue?vue&type=style&index=1&id=55f2dbce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f2dbce",
  null
  
)

export default component.exports